var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"d-block",attrs:{"name":"check-button","button":"","button-variant":"primary d-block rounded-0","size":"sm"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v(" "+_vm._s(_vm.checked ? "นำออก" : "เลือก")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }